import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
    watch: {
        showStepErrors: function(show) {
            if(show) {
                this.setError({ name: 'terms', value: !this.valid.terms})
                this.setError({ name: 'recaptcha', value: !this.valid.recaptcha})
            } else {
                this.clearErrors()
            }
        }
    },

    mounted() {

    },

    methods: {
        ...mapMutations( 'confirmation', [
            'setError',
            'clearErrors'
        ]),
    },

    computed: {
        ...mapState('products', {
            products: state => state.currentConfig,
        }),

        ...mapState('form', {
            form: state => state.fields,
        }),

        ...mapState('steps', {
            showStepErrors: state => state.three.showErrors,
        }),

        ...mapState('confirmation', {
            valid: state => state.valid,
            errors: state => state.errors,
        }),

        ...mapGetters('confirmation', {
            formIsValid: 'formIsValid'
        }),

        ...mapGetters('products', {
            formattedPrice: 'getFormattedPrice'
        }),

        terms: {
            get() { return this.$store.state.confirmation.fields.terms },
            set(value) { this.$store.commit('confirmation/setField', {name: 'terms', value}) }
        },

        recaptcha: {
            get() { return this.$store.state.confirmation.fields.recaptcha },
            set(value) { this.$store.commit('confirmation/setField', {name: 'recaptcha', value}) }
        },

        selectedNetSlots() {
            return Object.values(this.products['NET'].slots).filter(s => s.rate !== null)
        },

        selectedCellSlots() {
            return Object.values(this.products['CELL'].slots).filter(s => s.rate !== null)
        },

        selectedFixSlots() {
            return Object.values(this.products['FIX'].slots).filter(s => s.rate !== null)
        },

        selectedTvSlots() {
            return Object.values(this.products['TV'].slots).filter(s => s.rate !== null)
        },

        selectedPerseoSlots() {
            return Object.values(this.products['PERSEO'].slots).filter(s => s.rate !== null)
        }
    }
}
